<template>
    <jet-form-section @submitted="uploadFile">
        <template #title>
            File to import
        </template>

        <template #description>
            Select a csv file to import.
        </template>

        <template #form>
            <div class="col-span-6 sm:col-span-4">
                <input type="file" class="hidden" ref="importFile" @change="updateFileName">

                <div v-if="selectedFile">
                    {{ selectedFile }}
                </div>

                <jet-secondary-button class="mt-2 mr-2" type="button" @click.native.prevent="selectFile">
                    Select File to import
                </jet-secondary-button>

                <jet-input-error :message="form.errors.importFile" class="mt-2" />

                <HelpText>
                    Filename format: SAMPLE_SPLIT_data.csv (e.g. pooled_marital_data.csv)
                </HelpText>
            </div>
        </template>

        <template #actions>
            <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                Imported.
            </jet-action-message>

            <jet-action-message :on="form.processing" class="mr-3">
                Importing...
            </jet-action-message>

            <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Import
            </jet-button>
        </template>
    </jet-form-section>
</template>

<script>
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import JetActionMessage from '@/Jetstream/ActionMessage'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import HelpText from "@/Jetstream/HelpText.vue";

export default {
    components: {
        HelpText,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
    },

    props: ['user'],

    data() {
        return {
            form: this.$inertia.form({
                _method: 'PUT',
                importFile: null,
            }),

            selectedFile: null
        }
    },

    methods: {
        uploadFile() {
            if (this.$refs.importFile) {
                this.form.importFile = this.$refs.importFile.files[0]
            }

            this.form.post(route('intern.import.upload'), {
                errorBag: 'uploadFile',
                preserveScroll: true
            });
        },

        selectFile() {
            this.$refs.importFile.click();
        },

        updateFileName() {
            this.selectedFile = this.$refs.importFile.files[0].name
        }
    },
}
</script>
